export enum AuthProvider {
  Apple = 'apple',
  Google = 'google',
  Twitter = 'twitter',
}
